import { Component } from '@angular/core';
import { ReactPageComponent } from '../../../../common';
import { RelationshipsPage } from './page';

@Component({
  selector: 'app-page-relationships',
  template: '<div class="react-page" #container></div>'
})
export class PageRelationshipsComponent extends ReactPageComponent {
  get Component(){
    return RelationshipsPage;
  }
}